import DoubleChevronLeftSVG from '../../assets/svg/double-chevron-left.svg';

export default DoubleChevronLeftSVG;
